"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts_1 = require("./consts");
/**
 * Creates new render root.
 */
function createRenderRoot(document) {
    var renderTarget = document.createElement(consts_1.RENDER_TARGET_ELEMENT_TAG_NAME);
    adoptRenderRoot(renderTarget);
    return renderTarget;
}
exports.createRenderRoot = createRenderRoot;
/**
 * Adops existing render root.
 * We have to overwrite some api.
 */
function adoptRenderRoot(node) {
    var prop = {
        configurable: true,
        writable: true,
        value: null
    };
    Object.defineProperties(node, {
        previousSibling: prop,
        nextSibling: prop,
        previousElementSibling: prop,
        nextElementSibling: prop,
        assignedSlot: {
            get: function () {
                return undefined;
            }
        },
        index: {
            // but domino calculates it as renderTarget.parent.childNodes.indexOf(renderTarget)
            // renderTarget is not among its parent's children and domino throws
            configurable: true,
            writable: true,
            value: 0
        }
    });
}
exports.adoptRenderRoot = adoptRenderRoot;
